



























import { Consent } from "@/api/open-api";
import { QTable } from "quasar";
import Vue from "vue";
export default Vue.extend({
  name: "c-decimal-filter",
  props: ["id", "name", "value"],
  methods: {
    valueInitializer(value: string) {
      return value || "";
    },
    addZeroes(num: any) {
      num = num.toFixed(2);
    }
    // Return updated or original number.
  }
});
